export default "[mdcListItemGraphic] {\n  background-color: #eeeeee;\n}"